import request from "@/utils/request";
import Qs from "qs";

// 添加企业服务类型
export function qfTypeAdd(data) {
  return request({
    url: "/enterprise/add_type",
    method: "post",
    // ContentType:'multipart/form-data',
    data: Qs.stringify(data),
  });
}

// 编辑企业服务类型
export function qfTypeEdit(data) {
  return request({
    url: "/enterprise/edit_type",
    method: "post",
    data: Qs.stringify(data),
  });
}

// 删除企业服务类型
export function qfTypeDel(data) {
  return request({
    url: "/enterprise/del_type",
    method: "post",
    data: Qs.stringify(data),
  });
}

// 企业服务类型详情
export function qfTypeInfo(data) {
  return request({
    url: "/enterprise/type_info",
    method: "post",
    data: Qs.stringify(data),
  });
}

// 企业服务类型列表
export function qfTypeList(data) {
  return request({
    url: "/enterprise/type_list",
    method: "post",
    data: Qs.stringify(data),
  });
}

// 添加企业服务公司
export function qfServiceAdd(data) {
  return request({
    url: "/enterprise/add_service",
    method: "post",
    data: Qs.stringify(data),
  });
}

// 编辑企业服务公司
export function qfServiceEdit(data) {
  return request({
    url: "/enterprise/edit_service",
    method: "post",
    data: Qs.stringify(data),
  });
}

// 删除企业服务公司
export function qfServiceDel(data) {
  return request({
    url: "/enterprise/del_service",
    method: "post",
    data: Qs.stringify(data),
  });
}

// 企业服务公司详情
export function qfServiceInfo(data) {
  return request({
    url: "/enterprise/service_info",
    method: "post",
    data: Qs.stringify(data),
  });
}

// 企业服务公司列表
export function qfServiceList(data) {
  return request({
    url: "/enterprise/service_list",
    method: "post",
    data: Qs.stringify(data),
  });
}

// 获取企业服务类型
export function get_enter_types(data) {
  return request({
    url: "/common/get_enter_types",
    method: "post",
    data: Qs.stringify(data),
  });
}
